import { isImage } from './is-image.util';

/** The cap the single-image routes (avatar, logo) refuse above; a gallery takes more */
export const maxImageUploadMb = 10;

/** Why a picked file cannot be uploaded as an image, or null when it can */
export function checkImageFile(file: File, maxSizeMb = maxImageUploadMb): string | null {
  if (!isImage(file.type)) {
    return 'Please choose a JPG or PNG image';
  }

  if (file.size > maxSizeMb * 1024 * 1024) {
    return `The photo must be under ${maxSizeMb} MB`;
  }

  return null;
}
